import React, { Component } from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
// import Dropdown from 'react-toolbox/lib/dropdown';
import Checkbox from 'react-toolbox/lib/checkbox';
import LocationPicker from '~/components/LocationPicker';
import MultiPicker from '~/components/MultiPicker';

const defaults = {
  orderStatus: 'Todo'
};

const fields = {
  locationIds: MultiPicker(LocationPicker)
};

class ProductionQueueSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      outdata: {
        ...defaults,
        ...props.indata
      }
    };
  }

  componentDidMount() {
    this.onChange();
  }

  onChange() {
    this.props.onChange(this.state.outdata);
  }

  setOutdataValue(property, value) {
    this.setState(
      { outdata: { ...this.state.outdata, [property]: value } },
      this.onChange
    );
  }

  render() {
    const Cmp = fields.locationIds;

    return (
      <div>
        <Input
          value={this.state.outdata.title}
          onChange={val => this.setOutdataValue('title', val)}
          label="Title"
        />
        <Checkbox
          label="Distributor list?"
          checked={this.state.outdata.distributor}
          onChange={val =>
            this.setOutdataValue('distributor', val)
          }
        />
        {/* Calculation: warehouse count - container count = to produce */}
        {!this.state.outdata.distributor && (
          <div>
            <div>Warehouses to include in calcuation</div>
            <Cmp
              value={this.state.outdata.locationIdWarehouses}
              onChange={val =>
                this.setOutdataValue('locationIdWarehouses', val)
              }
            />
          </div>
        )}
        <div>Locations for containers to include in calculation</div>
        <Cmp
          value={this.state.outdata.locationIdContainers}
          onChange={val => this.setOutdataValue('locationIdContainers', val)}
        />
      </div>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(
  mapStateToProps,
  null,
  null,
  { pure: false }
)(ProductionQueueSettings);



// WEBPACK FOOTER //
// ./app/widgets.new/ProductionQueue/settings.js